<div>
    <h1>Services unavailable</h1>
    <br />
    <p>Some services are unavailable at this time. Please try again later.</p>
    <br />
    <p>Do you think this is an error? <a href="">Get in touch.</a></p>
    @if (message && message.length > 0) {
        <div>
            <br />
            <h3>Error message</h3>
            <pre>{{ message }}</pre>
        </div>
    }
</div>
